module.exports = __webpack_public_path__ + "img/icon_weather_211.ba60a315.svg";